import React, { useState } from "react";
import { CardHeader, Spinner } from "reactstrap";
import { FaQuestionCircle } from "react-icons/fa";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useGetUserFollowersQuery } from "../../../../store/api/userManagementApi";
import { useSelector } from "react-redux";

const FollowedUsers = () => {
    console.log("Rendering FollowedUsers");
    const userData = useSelector(state => state.userManagement.userData) || {};
    const user_id = userData?.user_id;
    const [currentPage, setCurrentPage] = useState(1);
    const sizePerPage = 100;
    const {
        data: followersResponse,
        isLoading,
        isFetching,
        error,
    } = useGetUserFollowersQuery(
        {
            userId: user_id,
            page: currentPage,
            limit: sizePerPage,
            connectionType: "followers",
        },
        { skip: !user_id }
    );
    const followers = followersResponse?.success ? followersResponse?.data || [] : [];
    const totalItems = followersResponse?.totalItems || followersResponse?.count || 0;
    const showLoading = isLoading || isFetching;
    const hasError = Boolean(error) || (followersResponse && followersResponse.success === false);
    const columns = [
        {
            dataField: 'user',
            text: '',
            formatter: (cell, row) => (
                <div className="d-flex align-items-center">
                    <img
                        src={row.image}
                        alt="User"
                        className="rounded-circle"
                        width="50"
                        height="50"
                    />
                    <div className="d-flex flex-column pl-2">
                        <strong>{row.name}</strong>
                    </div>
                </div>
            ),
            headerStyle: { width: '100%' },
            align: 'left',
            headerAlign: 'center'
        }
    ];

    const rowStyle = () => ({
        borderBottom: '1.5px solid #ddd'
    });

    const paginationOptions = {
        page: currentPage,
        sizePerPage,
        totalSize: totalItems,
        pageStartIndex: 1,
        paginationSize: 5,
        withFirstAndLast: true,
        alwaysShowAllBtns: true,
        hideSizePerPage: true,
    };

    return (
        <>
            <CardHeader className="bg-transparent border-bottom mb-3">
                <h4 className="mb-0">Followed Users</h4>
                <p className="text-muted small mb-0">
                    List of Followers for the user
                </p>
            </CardHeader>
            {
                showLoading
                    ? (
                        <div className="text-center p-5">
                            <Spinner color="primary" />
                            <p className="mt-2 text-muted">Loading followers...</p>
                        </div>
                    )
                    : hasError
                        ? (
                            <div className="text-center p-4">
                                <FaQuestionCircle size={40} className="text-muted mb-3" />
                                <p className="mb-0">Failed to fetch followers data</p>
                            </div>
                        )
                        : followers?.length === 0
                            ? (<div className="text-center p-4">
                                <FaQuestionCircle size={40} className="text-muted mb-3" />
                                <p className="mb-0">No followers found</p>
                            </div>
                            ) : (
                                <div className="tableList">
                                    <div className="ui-table-responsive new-table px-3">
                                        <BootstrapTable
                                            id="followers-table"
                                            keyField='id'
                                            data={followers}
                                            columns={columns}
                                            hover
                                            bordered={false}
                                            rowStyle={rowStyle}
                                            remote
                                            onTableChange={(type, { page }) => {
                                                if (type === 'pagination') {
                                                    setCurrentPage(page);
                                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                                }
                                            }}
                                            pagination={paginationFactory(paginationOptions)}
                                        />
                                    </div>
                                </div>
                            )
            }
        </>
    );
};

export default FollowedUsers;